// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index {
  background-color: #fbfbfb;
}
.index__main-container {
  background-color: #A1C7FF;
  position: relative;
}
.index__card-container {
  display: grid;
  grid-gap: 1rem;
  padding-bottom: 2rem;
  grid-template-columns: 1fr;
}
@media all and (min-width: 1280px) {
  .index__card-container {
    grid-gap: 20px;
    grid-template-columns: 1fr 1fr;
  }
}
.index__second-container--inner {
  position: relative;
  z-index: 9;
  padding: 0 1rem;
}
@media all and (min-width: 1280px) {
  .index__second-container--inner {
    padding: 0;
    max-width: 896px !important;
  }
}
.index__second-container--outer {
  background-color: #fbfbfb;
}
.index__heading {
  margin-bottom: 12px;
}
.index__description {
  margin-bottom: 1rem;
}
@media all and (min-width: 1280px) {
  .index__description {
    margin-bottom: 2rem;
  }
}
.index__with-who-we-play--outer {
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
  padding: 24px 16px 60px;
  background: linear-gradient(180deg, #1F48B1 0%, #0D1F4B 100%);
}
@media all and (min-width: 1280px) {
  .index__with-who-we-play--outer {
    border-top-left-radius: 80px;
    border-top-right-radius: 80px;
    padding: 32px 48px 90px;
  }
}
@media all and (min-width: 1280px) {
  .index__with-who-we-play--inner {
    padding-top: 1rem;
  }
}

.hero {
  position: relative;
  display: flex;
  justify-content: center;
}
.hero__image {
  position: relative;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/pages/Index/Index.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,yBC8BU;AD/BZ;AAGE;EACE,yBCKc;EDJd,kBAAA;AADJ;AAIE;EACE,aAAA;EACA,cAAA;EACA,oBAAA;EACA,0BAAA;AAFJ;AAII;EANF;IAOI,cAAA;IACA,8BAAA;EADJ;AACF;AAIE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;AAFJ;AAII;EALF;IAMI,UAAA;IACA,2BAAA;EADJ;AACF;AAIE;EACE,yBCDQ;ADDZ;AAKE;EACE,mBAAA;AAHJ;AAME;EACE,mBAAA;AAJJ;AAMI;EAHF;IAII,mBAAA;EAHJ;AACF;AAME;EACE,4BAAA;EACA,6BAAA;EACA,uBAAA;EACA,6DAAA;AAJJ;AAMI;EANF;IAOI,4BAAA;IACA,6BAAA;IACA,uBAAA;EAHJ;AACF;AAQI;EAFF;IAGI,iBAAA;EALJ;AACF;;AASA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AANF;AAQE;EACE,kBAAA;EACA,UAAA;AANJ","sourcesContent":["@import 'src/styles/variables';\n\n.index {\n  background-color: $white-100;\n\n  &__main-container {\n    background-color: $main-light-blue;\n    position: relative;\n  }\n\n  &__card-container {\n    display: grid;\n    grid-gap: 1rem;\n    padding-bottom: 2rem;\n    grid-template-columns: 1fr;\n\n    @media all and (min-width: $desktop) {\n      grid-gap: 20px;\n      grid-template-columns: 1fr 1fr;\n    }\n  }\n\n  &__second-container--inner {\n    position: relative;\n    z-index: 9;\n    padding: 0 1rem;\n\n    @media all and (min-width: $desktop) {\n      padding: 0;\n      max-width: 896px !important;\n    }\n  }\n\n  &__second-container--outer {\n    background-color: $white-100;\n  }\n\n  &__heading {\n    margin-bottom: 12px;\n  }\n\n  &__description {\n    margin-bottom: 1rem;\n\n    @media all and (min-width: $desktop) {\n      margin-bottom: 2rem;\n    }\n  }\n\n  &__with-who-we-play--outer {\n    border-top-left-radius: 32px;\n    border-top-right-radius: 32px;\n    padding: 24px 16px 60px;\n    background: linear-gradient(180deg, #1F48B1 0%, #0D1F4B 100%);\n\n    @media all and (min-width: $desktop) {\n      border-top-left-radius: 80px;\n      border-top-right-radius: 80px;\n      padding: 32px 48px 90px;\n    }\n  }\n\n  &__with-who-we-play--inner {\n\n    @media all and (min-width: $desktop) {\n      padding-top: 1rem;\n    }\n  }\n}\n\n.hero {\n  position: relative;\n  display: flex;\n  justify-content: center;\n\n  &__image {\n    position: relative;\n    z-index: 1;\n  }\n}\n\n","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
